/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbPcs_user" | "PdpSharedBlurbShipping_user" | "PdpSharedBlurbReturns_user" | "PdpSharedBlurbSupportNumber_user" | "consultAnExpert_user">;
    readonly " $refType": "PdpRespSidebarBlurbs_user";
};
export type PdpRespSidebarBlurbs_user$data = PdpRespSidebarBlurbs_user;
export type PdpRespSidebarBlurbs_user$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isVip",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbReturns_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isVip",
      "selections": [
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "isTrade",
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "consultAnExpert_user",
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "userRelationships",
                  "storageKey": "userRelationships(relationshipType:\"VIP\")",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "relationshipType",
                      "value": "VIP"
                    }
                  ],
                  "concreteType": "UserRelationship",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "userDataB",
                      "storageKey": null,
                      "args": null,
                      "concreteType": null,
                      "plural": true,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "type": "VipRepData",
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "displayName",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'f77850d3392e9259cade2e3a509d68a4';
export default node;
